export enum Role {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_ORG_ADMIN = "ROLE_ORG_ADMIN",
  ROLE_USER = "ROLE_USER",
  ROLE_MOBILE_USER = "ROLE_MOBILE_USER",
}

export enum Operations {
  PERSON_EDIT = "PERSON_EDIT",
  MOBILE_USER_EDIT = "MOBILE_USER_EDIT",
}

export enum Resources {
  DASHBOARD = "DASHBOARD",
}

export const resources = {
  [Resources.DASHBOARD]: [Role.ROLE_ADMIN, Role.ROLE_ORG_ADMIN],
};

export const operations = {
  [Operations.PERSON_EDIT]: [Role.ROLE_ADMIN, Role.ROLE_ORG_ADMIN],
  [Operations.MOBILE_USER_EDIT]: [Role.ROLE_ADMIN, Role.ROLE_ORG_ADMIN],
};

export default Role;
